export default __webpack_public_path__ + "static/media/submenu-robot-c4.7c1b2412.png";